import { ADMIN_HOST } from 'utils/variables/constants'
import { MicroFrontend } from './microFrontend'

export const AdminMicroFrontend = (): JSX.Element => {
  return <MicroFrontend host={ADMIN_HOST} name="Admin" />
}
